import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { TokenComponent } from './token/token.component';

export const routes: Routes = [
  {
    path: 'app/issues/:issueKey',
    component: HomeComponent,
  },
  { path: 'app/obsidian-token/:issueKey', component: TokenComponent },
];
